import type { PromptPurpose } from './types.js';

/**
 * C2 Q1 — `PromptSourceBundle.connected` requirement:
 * - REQUIRED (fail-fast PromptCompileError): world_devices, character_options, runtime_scene
 * - OPTIONAL: connected_questions (answers + dependency graph suffice during wizard)
 * - OPTIONAL: assumption, location_summary, missed_activity
 * Enforced in compilers/base.ts `assertConnectedContext`.
 */
export type PersistencePolicy = 'none' | 'draft' | 'world' | 'runtime';

export interface OperationContract {
  outputSchemaId: string;
  persistencePolicy: PersistencePolicy;
  structuredOutput: boolean;
}

export const OPERATION_CONTRACTS: Record<PromptPurpose, OperationContract> = {
  connected_questions: {
    outputSchemaId: 'ConnectedQuestionsOutput',
    persistencePolicy: 'draft',
    structuredOutput: true,
  },
  assumption: {
    outputSchemaId: 'AssumptionOutput',
    persistencePolicy: 'draft',
    structuredOutput: true,
  },
  world_devices: {
    outputSchemaId: 'WorldDevicesOutput',
    persistencePolicy: 'world',
    structuredOutput: true,
  },
  character_options: {
    outputSchemaId: 'CharacterOptionsOutput',
    persistencePolicy: 'draft',
    structuredOutput: true,
  },
  runtime_scene: {
    outputSchemaId: 'RuntimeSceneOutput',
    persistencePolicy: 'runtime',
    structuredOutput: true,
  },
  location_summary: {
    outputSchemaId: 'SummaryOutput',
    persistencePolicy: 'runtime',
    structuredOutput: true,
  },
  missed_activity: {
    outputSchemaId: 'SummaryOutput',
    persistencePolicy: 'runtime',
    structuredOutput: true,
  },
};

export class PromptCompileError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PromptCompileError';
  }
}
